// modules/records/hooks/useRecordActions.ts

import { evaluateCondition } from "shared/services/conditionEvaluatorForActions";
import { RecordActionConditionContext } from "modules/record/record-producer/types/record-producer-actions";
import useFormActions from "modules/record/shared/hooks/useFormActions";

const useRecordProducerRelatedActions = (tableName: string, context: RecordActionConditionContext) => {
    const { actions, isLoading } = useFormActions(tableName);


    return {
        actions: actions
            .filter(action => action.is_form_action === false && action.is_list_action === false && action.is_related_action === true)
            .filter(action => evaluateCondition(action.conditions, context))
            .sort((a, b) => a.order - b.order),
        isLoading
    }
}

export default useRecordProducerRelatedActions;
